import { Paperclip } from "@/components/ui/icons";
import { CoworkerIcon } from "@/components/ui/coworker-icon";

interface DropOverlayProps {
  isDraggingFiles: boolean;
  isDraggingCard: boolean;
}

export function DropOverlay({
  isDraggingFiles,
  isDraggingCard,
}: DropOverlayProps) {
  if (!isDraggingFiles) return null;
  return (
    <div className="absolute inset-x-0 top-[86px] bottom-0 bg-overlay/85 flex items-end justify-center pb-20 pointer-events-none z-10">
      <div className="flex items-center gap-2 text-foreground bg-overlay/60 px-4 py-2 rounded-full">
        {isDraggingCard ? (
          <>
            <CoworkerIcon size={18} />
            <span className="font-medium">Drop to share in chat</span>
          </>
        ) : (
          <>
            <Paperclip size={18} />
            <span className="font-medium">Drop files to attach</span>
          </>
        )}
      </div>
    </div>
  );
}
